export default __webpack_public_path__ + "static/allProjects2-dcd889d8dff4f646443ab0dd097b4246.png";